import { c as _c } from "react/compiler-runtime";
export default function SubscriptionToggle(t0) {
  const $ = _c(17);
  const {
    billingInterval,
    setBillingInterval,
    isCurrentTier
  } = t0;
  const offBg = isCurrentTier ? "#1d4ed8" : "#fff";
  const onBg = isCurrentTier ? "#fff" : "#002766";
  const offThumb = isCurrentTier ? "#fff" : "#002766";
  const onThumb = isCurrentTier ? "#002766" : "#fff";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>Monthly</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Switch to ${billingInterval === "month" ? "year" : "month"} subscription`;
  const t3 = billingInterval === "month" ? offBg : onBg;
  let t4;
  if ($[1] !== t3) {
    t4 = {
      backgroundColor: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== billingInterval || $[4] !== setBillingInterval) {
    t5 = () => setBillingInterval(billingInterval === "month" ? "year" : "month");
    $[3] = billingInterval;
    $[4] = setBillingInterval;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = billingInterval === "month" ? "translateX(3px)" : "translateX(100%)";
  const t7 = billingInterval === "month" ? offThumb : onThumb;
  let t8;
  if ($[6] !== t6 || $[7] !== t7) {
    t8 = <div className="h-5 w-5 rounded-full transition-transform duration-300 ease-in-out" style={{
      transform: t6,
      background: t7
    }} />;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t5 || $[12] !== t8) {
    t9 = <button aria-label={t2} className="border-neutral-3 h-[23px] w-[40px] rounded-full border" style={t4} type="button" onClick={t5}>{t8}</button>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div>Yearly</div>;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <div className="relative flex flex-row items-center gap-x-2 text-base font-normal">{t1}{t9}{t10}</div>;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}